module.exports = __webpack_public_path__ + "static/img/tphdeng.5e60c368.png";